import { Update } from '@ngrx/entity';
import { createAction, props } from '@ngrx/store';
import { PostingType } from '../../lookups';
import { ServiceItem } from './service-item.model';

export const loadServiceItems = createAction(
    '[ServiceItem/API] Load ServiceItems',
    props<{ serviceItems: ServiceItem[] }>()
);

export const addServiceItem = createAction(
    '[ServiceItem/API] Add ServiceItem',
    props<{ serviceItem: ServiceItem }>()
);

export const upsertServiceItem = createAction(
    '[ServiceItem/API] Upsert ServiceItem',
    props<{ serviceItem: ServiceItem }>()
);

export const addServiceItems = createAction(
    '[ServiceItem/API] Add ServiceItems',
    props<{ serviceItems: ServiceItem[] }>()
);

export const upsertServiceItems = createAction(
    '[ServiceItem/API] Upsert ServiceItems',
    props<{ serviceItems: ServiceItem[] }>()
);

export const updateServiceItem = createAction(
    '[ServiceItem/API] Update ServiceItem',
    props<{ serviceItem: Update<ServiceItem> }>()
);

export const updateServiceItems = createAction(
    '[ServiceItem/API] Update ServiceItems',
    props<{ serviceItems: Update<ServiceItem>[] }>()
);

export const deleteServiceItem = createAction(
    '[ServiceItem/API] Delete ServiceItem',
    props<{ id: string }>()
);

export const deleteServiceItems = createAction(
    '[ServiceItem/API] Delete ServiceItems',
    props<{ ids: string[] }>()
);

export const clearServiceItems = createAction(
    '[ServiceItem/API] Clear ServiceItems'
);

export const getServiceItems = createAction(
    '[ServiceItem/API] Get ServiceItems'
);

export const postServiceItems = createAction(
    '[ServiceItem/API] Post ServiceItems',
    props<{ SIListIds: string[] }>()
);

export const putServiceItems = createAction(
    '[ServiceItem/API] Put ServiceItems',
    props<{ items: Partial<ServiceItem>[] }>()
);

export const getServiceItemPostingTypes = createAction(
    '[ServiceItem/API] Get Service Item Posting Types'
);

export const loadServiceItemPostingTypes = createAction(
    '[ServiceItem/API] Load Service Item Posting Types',
    props<{ ServiceItemPostingTypes: PostingType[] }>()
);
